// Module
var code = `<div class="menu-holder"></div>

<div class="code-container-reference-holder">
  <div class="code-container-content-holder"></div>
</div>
`;
// Exports
module.exports = code;